'use es6';

import Client from 'AdsUI/data/Client';
import I18n from 'I18n';
const profileUrl = 'ads/v1/profile';
export default {
  fetch() {
    return Client.apiRequest(`${profileUrl}/desired-cost-per-lead`);
  },

  syncCostPerLead(costPerLead) {
    const data = Object.assign({}, costPerLead, {
      avgSalePrice: I18n.parseNumber(costPerLead.avgSalePrice)
    });
    return Client.apiRequest(`${profileUrl}/desired-cost-per-lead`, {
      type: 'PUT',
      data
    });
  },

  syncROISetting(roiType) {
    return Client.apiRequest(`${profileUrl}/roi-setting`, {
      type: 'POST',
      data: {
        roiType
      }
    });
  }

};